import { xhr } from '@shared/config';

import { showPopup } from '@src/library/redux/modal';

import { useAppDispatch } from './use-app-dispatch';
import { useAuthToken } from './use-auth-token';
import { useCookies } from './use-cookies';

export const useInterceptors = () => {
	const dispatch = useAppDispatch();
	const { token, removeToken } = useAuthToken();
	const { removeCookie } = useCookies();

	xhr.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			if (error.response.status === 401) {
				// console.log('ошибка авторизации');
				removeCookie('csrftoken');
				removeCookie('sessionid');

				if (token) {
					removeToken();
					return (window.location.href = '/');
				}
			}

			if (error.response.status === 502) {
				// console.log('технические работы');
				if (window.location.href.search('technical-service') === -1) {
					return (window.location.href = '/technical-service');
				}
			}

			if (error.response?.status === 403) {
				dispatch(showPopup({ type: 'error', text: '403: Недостаточно пользовательских прав' }));
				return;
			}

			if (error.response?.status === 500) {
				dispatch(showPopup({ type: 'error', text: '500: Неизвестная ошибка' }));
				return;
			}

			return error;
		}
	);
};
